<template>
  <div>
    <div class="service">
    <a href="http://www.5ifbi.com/fbidown/" target="blank">
      <div class="firstdiv">
        <i class="el-icon-document"></i>
        <p class="p_name">产品下载</p>
      </div>
    </a>
    <!-- <button @click="top_one = !top_one">改变</button> -->
    <div @click="getUrl()  ">
      <i class="el-icon-headset"></i>
      <p class="p_name">在线客服</p>
    </div>
    <el-popover placement="left-start" width="12.5rem" trigger="hover">
      <img src="../../assets/image/wechat.png" alt />
      <div slot="reference">
        <i class="iconfont icon-icon-"></i>
        <p class="p_name">公众号</p>
      </div>
    </el-popover>

    <div @click="suggest">
      <i class="el-icon-message"></i>
      <p class="p_name">意见反馈</p>
    </div>

   
  </div>
    <div class="go_top" @click="backTop" v-if="isShow" @mouseenter="mouseenter" @mouseleave="mouseleave">
      <div  v-show="top_one">
        <!-- 黑色 -->
        <img src="@/assets/image/top.png" alt="">
      </div>
      <div v-show="!top_one">
        <!-- 白色 -->
        <img  src="@/assets/image/top2.png" alt="">
      </div>
      
    </div>
  </div>
 
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      iframeout: false,
      isShow:false,
      scrollTop:0,
      top_one:true
    }
  },
  methods: {
    mouseenter(){
      
    },
    mouseleave(){

    },
    iframeput() {
      this.iframeout = true
    },
    getUrl() {
      let routeData = this.$router.resolve({ path: '/service' })
      var arr = screen.width
      console.log(arr)
      window.open(
        routeData.href,
        '_blank',
        'location=no ,width=1000,height=710 ,top=100,left=' +
          (arr - 1000) / 2 +
          ',resizable=no, menubar=no,toolbar=no,status=no,scrollbars=no'
      )
    },
    suggest() {
      window.open('http://help.tizdata.com/option?parduct=FastBI产品',"_blank")
    },
    backTop () {
        const that = this
        let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
        }, 16)
  },
  showbtn(){
      let that = this
        that.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
       if(that.scrollTop > 100){
          this.isShow = true
        }else{
          this.isShow = false
        }
  }

  },
  mounted(){
    window.addEventListener('scroll',this.showbtn,true);
  },
  beforeDestroy() {
    this.iframeout = false
  },
}
</script>

<style lang='less' scoped>
.service {
  width: 70px;
  min-height: 100px;
  /* background-color: blue; */
  position: fixed;
  bottom: 80px;
  right: 10px;
  display: flex;
  background-color: #fff;
  justify-content: center;
  flex-wrap: wrap;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
  @media screen and (max-height: 600px) {
    display: none;
  }
  div {
    width: 70px;
    height: 70px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 10px;
    padding-bottom: 5px;
    border-radius: 5px;
  }

  .firstdiv {
    margin-top: 0;
    i {
      color: #000000;
    }
  }

}
.go_top{
    width: 70px;
    height: 30px;
    position: fixed;
    bottom: 40px;
    right: 10px;
 
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
    img{
      width: 18px;
      height: 18px;
    }
    @media screen and (max-height: 600px) {
    display: none;
   
    } 
  }
  .go_top div{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    padding-top: 5px;
    background-color:#fff ; 
  }
  .go_top div:hover{  
    background-color: #0187ff; 
  }
  .go_top div:active{  
    // background-color: rgb(25, 103, 254); 
  }

.service div:hover {
  background-color: #0187ff;
  cursor: pointer;
  .icon-icon-,
  .el-icon-document,
  .el-icon-headset,
  .el-icon-message {
    color: #eeeeee;
  }
  .p_name {
    color: #eeeeee;
  }
}

.el-icon-document,
.el-icon-headset,
.el-icon-message {
  font-size: 30px;
  /* color: white; */
  margin-top: 10px;
  width: 50px;
  text-align: center;
}
.icon-icon- {
  font-size: 35px;
  width: 50px;
  height: 35px;
  text-align: center;
}

.p_name {
  color: #000000;
  font-size: 10px;
}
.el-popover {
  img {
    margin-left: 7px;
    margin-top: 12px;
  }
}
</style>
